import axios from "@/axios";

export const namespaced = true

export const state = {
    stockClasses: [],
    stockSubClasses: [],
}

export const getters = {
    stockClasses: state => state.stockClasses,
    stockSubClasses: state => state.stockSubClasses,
}
    
export const mutations = {
    SET_STOCK_CLASSES: (state, response) => state.stockClasses = response.data, 
    SET_STOCK_SUB_CLASSES: (state, response) => state.stockSubClasses = response.data, 
}

export const actions = {
    async getStockClasses({commit}){
        commit("SET_STOCK_CLASSES", await axios.get('/api/stockclasses/'));
    },
    async getStockSubClasses({commit}, stockClassId){
        commit("SET_STOCK_SUB_CLASSES", await axios.get(`/api/stocksubclasses/supply/${stockClassId}`))
    }
}
